var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5207 18.5444C20.8276 18.2527 21 17.857 21 17.4444V8.88889C21 8.47633 20.8276 8.08067 20.5207 7.78894C20.2138 7.49722 19.7976 7.33333 19.3636 7.33333H16.0909L14.4545 5H9.54545L7.90909 7.33333H4.63636C4.20237 7.33333 3.78616 7.49722 3.47928 7.78894C3.1724 8.08067 3 8.47633 3 8.88889V17.4444C3 17.857 3.1724 18.2527 3.47928 18.5444C3.78616 18.8361 4.20237 19 4.63636 19H19.3636C19.7976 19 20.2138 18.8361 20.5207 18.5444Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCamera;